/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Posts_CountInputs */

const en_admin_posts_count = /** @type {(inputs: Admin_Posts_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} posts`)
};

const zh_admin_posts_count = /** @type {(inputs: Admin_Posts_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 篇`)
};

/**
* | output |
* | --- |
* | "{count} posts" |
*
* @param {Admin_Posts_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_count = /** @type {((inputs: Admin_Posts_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_count(inputs)
	return zh_admin_posts_count(inputs)
});
export { admin_posts_count as "admin.posts.count" }